export default __webpack_public_path__ + "static/game-bahrain-f76fc5cde6411ddf0ac36f32c14585d3.webp";